module.exports = __webpack_public_path__ + "img/v_img.d7cff5bd.svg";